export default __webpack_public_path__ + "static/media/Legguards of the Anguished Heart.86bb10fa.jpg";